import React from 'react';
import { WebsiteDesignProps } from './types';
import { Grid, Plus } from 'lucide-react';
import { Button } from "@/components/ui/button";

const SwissGrid: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Helvetica Institute";

    return (
        <div className="bg-[#e6e6e6] min-h-screen font-sans text-black">
            <div className="max-w-[1440px] mx-auto bg-white min-h-screen shadow-2xl overflow-hidden relative">
                {/* Grid Lines */}
                <div className="absolute inset-0 pointer-events-none z-20 flex bg-transparent">
                    <div className="flex-1 border-r border-red-500/20 h-full"></div>
                    <div className="flex-1 border-r border-red-500/20 h-full"></div>
                    <div className="flex-1 border-r border-red-500/20 h-full"></div>
                    <div className="flex-1 h-full"></div>
                </div>

                <header className="p-8 border-b border-black grid grid-cols-4 relative z-30">
                     <div className="col-span-2 text-4xl font-bold tracking-tight leading-none uppercase">
                         {schoolName} <span className="text-red-600">.CH</span>
                     </div>
                     <div className="col-span-2 text-right text-xs font-bold font-mono">
                         DESIGN • SYSTEMS • OBJECTIVITY
                     </div>
                </header>

                <main className="grid grid-cols-1 md:grid-cols-4 min-h-[80vh] relative z-30">
                    <div className="col-span-2 p-8 border-r border-black flex flex-col justify-between">
                         <div>
                             <h1 className="text-7xl font-bold leading-none mb-4 -ml-1">
                                 ORDER <br/> IS FORM.
                             </h1>
                             <div className="w-16 h-16 bg-red-600 rounded-full mt-8"></div>
                         </div>
                         <div className="text-lg font-medium leading-tight max-w-sm">
                             We teach the fundamental principles of design and logic. Clear communication above all else.
                         </div>
                    </div>
                    
                    <div className="col-span-2 relative overflow-hidden group bg-black">
                         <img src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover opacity-60 grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" alt="Architecture" />
                         <div className="absolute bottom-0 left-0 bg-white p-4 font-bold text-xs uppercase tracking-widest">
                             Figure 01: Campus Exterior
                         </div>
                    </div>
                </main>

                <section className="border-t border-black bg-black text-white p-8 relative z-30">
                     <div className="grid grid-cols-4 gap-8">
                         <div className="col-span-1 border-t border-white pt-2">
                             <h3 className="text-xl font-bold mb-2">Admissions</h3>
                             <p className="text-xs text-gray-400">Open for Fall 2026</p>
                             <div className="mt-4"><Plus /></div>
                         </div>
                         <div className="col-span-1 border-t border-white pt-2">
                             <h3 className="text-xl font-bold mb-2">Curriculum</h3>
                             <p className="text-xs text-gray-400">Modular Learning</p>
                             <div className="mt-4"><Grid /></div>
                         </div>
                         <div className="col-span-2 flex justify-end items-center">
                             <Button className="bg-white text-black hover:bg-red-600 hover:text-white rounded-none h-12 px-8 font-bold uppercase transition-colors">
                                 Apply Now
                             </Button>
                         </div>
                     </div>
                </section>
            </div>
        </div>
    );
};

export default SwissGrid;
